import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import FileUploader from "../videos/FileUploader";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const UploadAudio = () => {
  const navigate=useNavigate()
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [files, setFiles] = useState(null)
  const [radiocheck, setRadioCheck] = useState('')
  const [category, setCategory] = useState('')
  const [subCategory, setSubCategory] = useState('')
  const [description, setDescription] = useState('')
  const [courseName, setCourseName] = useState("");
  const [price, setPrice] = useState('')
  const [isUploading, setIsUploading] = useState(false)
  const [addtionalRescoures,setAdditionalResources] = useState([])

 useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/categories/list/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      });

      setCategories(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  fetchCategories();
}, []);

  const handleCategoryChange = (e) => {
    const categoryId = parseInt(e.target.value);
    setSelectedCategory(categoryId);
    setCategory(e.target.value)
    const category = categories.find((cat) => cat.id === categoryId);
    setSubcategories(category ? category.subcategories : []);
    setSelectedSubcategory(null);
    setSubCategory('')
  };

  
const handleSubmit = async (e) => {
  e.preventDefault();

  // Validation
  if (!files || files.length === 0) {
    alert(`Please upload a Audio first!`);
    return;
  }

  if (!courseName || !description || !selectedCategory || !selectedSubcategory || !radiocheck) {
    alert("Please fill all required fields!");
    return;
  }

  setIsUploading(true);

  // Prepare form data
  const formData = new FormData();
  formData.append("file", files[0]);
  formData.append("category", selectedCategory ? parseInt(selectedCategory) : "");
  formData.append("subcategory", selectedSubcategory ? parseInt(selectedSubcategory) : "");
  formData.append("description", description);
  formData.append("name", courseName);
  formData.append("course_type", radiocheck);
  addtionalRescoures.forEach((file)=>{
    formData.append('resources',file)
  })
  if (radiocheck === "paid") {
    formData.append("price", price);
  }
  try {
  const response = await axios.post(
    `${BASE_URL}/courses/audio/`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY,
      },
    }
  );

  alert("Audio uploaded successfully!");
  resetForm();
  navigate("/teacher/audios");
} catch (error) {
  console.error(error);
  alert(error.response?.data?.msg || "An error occurred during upload.");
} finally {
  setIsUploading(false);
}
};

  const resetForm = () => {
    setFiles(null)
    setRadioCheck("")
    setSelectedCategory(null)
    setSelectedSubcategory(null)
    setDescription("")
    setCourseName("")
    setPrice("")
    setSubcategories([])
  }

  return (
   <div className="min-h-screen  flex justify-center items-center p-4">
  <div className="max-w-5xl w-full my-4 p-8 rounded-2xl bg-white border border-gray-200 shadow-sm">

    {/* Header with icon */}
    <div className="flex items-center gap-3 mb-8">
      <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
    </svg>
      </div>
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Upload Your Audio</h2>
        <p className="text-sm text-gray-500 mt-1">Share your knowledge with the community</p>
      </div>
    </div>

    <form onSubmit={handleSubmit} className="space-y-6">
      <FileUploader files={files} setFiles={setFiles} type="Audio" />

      {/* Title */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">
            Audio Title <span className="text-red-500">*</span>
          </label>
        </div>
        <input
          type="text"
          value={courseName}
          onChange={(e) => setCourseName(e.target.value)}
          placeholder="Enter course title"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          required
        />
      </div>

      {/* Description */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">
            Description <span className="text-red-500">*</span>
          </label>
        </div>
        <textarea
          required
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={4}
          placeholder="Write a description..."
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-y min-h-[100px]"
        />
      </div>

      {/* Category */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">
            Category <span className="text-red-500">*</span>
          </label>
        </div>
        <select
          required
          onChange={handleCategoryChange}
          value={selectedCategory || ""}
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 16px center'
          }}
        >
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>

      {/* Subcategory */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">
            Sub-Category <span className="text-red-500">*</span>
          </label>
        </div>
        <select
          required
          disabled={!selectedCategory}
          onChange={(e) => {
            setSelectedSubcategory(e.target.value);
            setSubCategory(e.target.value);
          }}
          value={selectedSubcategory || ""}
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none disabled:opacity-50 disabled:cursor-not-allowed"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 16px center'
          }}
        >
          <option value="">Select Subcategory</option>
          {subcategories.map((sub) => (
            <option key={sub.id} value={sub.id}>
              {sub.name}
            </option>
          ))}
        </select>
      </div>

      {/* Pricing */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">
            Pricing <span className="text-red-500">*</span>
          </label>
        </div>
        <div className="flex gap-4 flex-col md:flex-row">
          <label className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-xl border-2 cursor-pointer transition-all ${
            radiocheck === "free"
              ? "bg-[#e8f0f7] border-[#0f6abf] text-[#0f6abf]"
              : "bg-gray-50 border-gray-300 text-gray-700 hover:border-gray-400"
          }`}>
            <input
              required
              type="radio"
              name="pricing"
              checked={radiocheck === "free"}
              onChange={() => {
                setRadioCheck("free");
                setPrice("");
              }}
              className="w-4 h-4 accent-[#0f6abf]"
            />
            <span className="font-medium">Free</span>
          </label>
          <label className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-xl border-2 cursor-pointer transition-all ${
            radiocheck === "paid"
              ? "bg-[#e8f0f7] border-[#0f6abf] text-[#0f6abf]"
              : "bg-gray-50 border-gray-300 text-gray-700 hover:border-gray-400"
          }`}>
            <input
              type="radio"
              name="pricing"
              checked={radiocheck === "paid"}
              onChange={() => setRadioCheck("paid")}
              className="w-4 h-4 accent-[#0f6abf]"
            />
            <span className="font-medium">Paid</span>
          </label>
        </div>
      </div>

      {/* Price */}
      {radiocheck === "paid" && (
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <label className="text-sm font-semibold text-gray-700">
              Price <span className="text-red-500">*</span>
            </label>
          </div>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="Price (USD)"
            min="0"
            step="0.01"
            required
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
        </div>
      )}

      {/* Additional Resources */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">
            Additional Resources
          </label>
        </div>
        <div className="relative">
          <input
            type="file"
            name="files"
            multiple
            onChange={(e) => setAdditionalResources([...e.target.files])}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
          />
          <div className="w-full px-4 py-8 bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors">
            <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mx-auto mb-3">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
              </svg>
            </div>
            <p className="text-sm text-gray-600">Click to upload additional resources</p>
            <p className="text-xs text-gray-400 mt-1">PDF, DOC, ZIP up to 50MB</p>
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={isUploading}
        className="w-full py-3.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        {isUploading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Uploading...
          </>
        ) : (
          <>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
            </svg>
            Upload Audio
          </>
        )}
      </button>
    </form>
  </div>
</div>

  )
}

export default UploadAudio